<cb-dialog [dialogHeading]="dialogHeading()" *cbWaitFor="mappedItem">
    <form class="flex-col flex" #itemForm="ngForm" id="itemForm">
        @if (isAdd()) {
            <cb-select
                label="House Area"
                name="name"
                [(ngModel)]="mappedItem.specGroupId"
                [options]="houseAreas"
                [disabled]="isLotSpecLocked$ | async"
                [required]="true"
                (ngModelChange)="houseAreaUpdated()"
            >
            </cb-select>
        }
        @if (isAdd()) {
            <cb-slot-autocomplete-scroller
                #scrollerComponent
                class="cb-margin-top flex flex-row"
                label="Schedule Item Name"
                name="newChildSlot"
                style="min-width: 300px"
                [(ngModel)]="selectedScheduleItem"
                [requireMatch]="true"
                [matchProps]="['id']"
                [specGroupId]="mappedItem.specGroupId"
                [disabled]="!(mappedItem?.specGroupId > 0)"
                (optionSelected)="scheduleItemSelected($event)"
                [required]="true"
                [excludeIds]="data?.slotIdListByGroupId[mappedItem.specGroupId]"
            >
            </cb-slot-autocomplete-scroller>
        }
        @if (isEdit()) {
            <cb-display-value-new [value]="mappedItem.slotName" label="Schedule Item Name">
            </cb-display-value-new>
        }
        @if (isEdit()) {
            <cb-display-value-new [value]="mappedItem.specGroupLabel" label="House Area">
            </cb-display-value-new>
        }
        @if (isQuoted()) {
            <cb-display-value-new [value]="COST_TYPE_ENUM[mappedItem.costType]" label="Cost Type">
            </cb-display-value-new>
        }
        @if (!isQuoted() && !updatingScheduleItem) {
            <cb-select
                name="costType"
                label="Cost Type"
                [disabled]="isLotSpecLocked$ | async"
                [options]="scheduleTemplateCostTypes"
                [required]="true"
                [(ngModel)]="mappedItem.costType"
                (change)="clearProductForCostType()"
            >
            </cb-select>
        }
        <mat-card class="cb-margin-top-2x flex-col flex">
            <mat-card-content>
                <h4 class="mat-h4 cb-margin-bottom-2x">
                    <b>Item Details</b>
                </h4>
                @if (isNotDescriptive()) {
                    <cb-display-value-new
                        [value]="
                            mappedItem?.slotCategory?.id > 0
                                ? mappedItem.slotCategory.categoryPath
                                : mappedItem?.category?.categoryPath
                        "
                        label="Product Category"
                    >
                    </cb-display-value-new>
                }
                @if (isDescriptiveOnly() && !isQuoted()) {
                    <cb-text-area
                        name="description"
                        label="Description"
                        [disabled]="isLotSpecLocked$ | async"
                        [required]="true"
                        [maxlength]="1500"
                        [(ngModel)]="mappedItem.productLabel"
                        (change)="descriptionTextChanged()"
                    >
                    </cb-text-area>
                }
                @if (isQuoted()) {
                    <cb-display-value-new [value]="mappedItem.productLabel" label="Description">
                    </cb-display-value-new>
                }
                <div class="start-center flex-row">
                    @if (isNotDescriptive() && !isQuoted()) {
                        <div class="flex">
                            <cb-product-centre-autocomplete-scroller
                                class="cb-margin-right flex"
                                label="Product"
                                name="product"
                                [maxlength]="1499"
                                [disabled]="isLotSpecLocked$ | async"
                                [(ngModel)]="selectedProduct"
                                [required]="true"
                                [businessEntityIds]="businessEntityIdAndNationalId"
                                [requireMatch]="isActual()"
                                [matchProps]="['id']"
                                [hideCompositeItems]="false"
                                [orderByStandardProduct]="true"
                                [categoryId]="
                                    mappedItem?.slotCategory?.id > 0
                                        ? mappedItem.slotCategory.id
                                        : undefined
                                "
                                (searchTextChanged)="productSearchTextChanged($event)"
                                (optionSelected)="productUpdate($event)"
                            >
                            </cb-product-centre-autocomplete-scroller>
                        </div>
                    }
                    @if (isNotDescriptive() && !isQuoted()) {
                        <cb-product-centre-find
                            name="selectedProduct"
                            class="product-centre-find"
                            [initializeSearchOnLoad]="true"
                            [categoryIdFilter]="
                                mappedItem?.slotCategory?.id > 0
                                    ? mappedItem.slotCategory.id
                                    : undefined
                            "
                            [businessEntityIdsToSortBy]="businessEntityIdAndNationalId"
                            [restrictedBusinessEntityIds]="businessEntityIdAndNationalId"
                            [existingSlotItem]="existingSlotItem"
                            [showCurrentProduct]="true"
                            [currentProductTitle]="'Current Lot Spec Item'"
                            [hideNationalRate]="true"
                            (productSelected)="productUpdate($event, true)"
                            [required]="true"
                            [buttonOnly]="true"
                            [maxlength]="1499"
                            [activeOnly]="true"
                            [disabled]="isLotSpecLocked$ | async"
                        >
                        </cb-product-centre-find>
                    }
                </div>
                <cb-text-area
                    label="Text for Specification"
                    name="textForSpecification"
                    [(ngModel)]="mappedItem.clientFriendlyDescription"
                    [maxlength]="1500"
                >
                </cb-text-area>
                @if (!isQuoted()) {
                    <cb-input
                        type="number"
                        label="Quantity"
                        [disabled]="isLotSpecLocked$ | async"
                        [required]="true"
                        [(ngModel)]="mappedItem.quantity"
                        name="quantity"
                    ></cb-input>
                }
                @if (isQuoted()) {
                    <cb-display-value-new [value]="mappedItem.quantity" label="Quantity">
                    </cb-display-value-new>
                }
                @if (showAmount() && !isQuoted()) {
                    <cb-currency
                        [label]="getAmountLabel()"
                        name="rateSnapshot"
                        [(ngModel)]="mappedItem.rateSnapshot"
                        [required]="false"
                        [disabled]="isLotSpecLocked$ | async"
                        [inclGst]="isProvisional()"
                    ></cb-currency>
                }
                @if (isQuoted()) {
                    <cb-currency
                        label="Quote Amount"
                        name="rateSnapshot"
                        [disabled]="isLotSpecLocked$ | async"
                        [ngModel]="mappedItem.rateSnapshot"
                        [readonly]="true"
                    >
                    </cb-currency>
                }
                @if (isNotDescriptive() && !isQuoted()) {
                    <cb-select
                        label="Supplier"
                        name="supplier"
                        [disabled]="isLotSpecLocked$ | async"
                        [(ngModel)]="mappedItem.supplierId"
                        [options]="mappedItem.suppliers"
                    ></cb-select>
                }
                @if (isQuoted()) {
                    <cb-display-value-new [value]="mappedItem.supplierDisplay" label="Supplier">
                    </cb-display-value-new>
                }
                @if (isQuoted()) {
                    <cb-display-value-new [value]="mappedItem.qRef" label="QRef">
                    </cb-display-value-new>
                }
            </mat-card-content>
        </mat-card>
        <mat-card class="cb-margin-top-2x cb-margin-bottom-2x flex-col flex">
            <mat-card-content>
                <h4 class="mat-h4 cb-margin-bottom-20">
                    <b>Item Attributes</b>
                </h4>
                <div class="flex-row flex">
                    <div class="cb-margin-right-3x image-block">
                        <div class="product-image">
                            <img [src]="getImageUrl()" cbHandleInvalidImage alt="Product Image" />
                            <button class="view" mat-mini-fab (click)="viewImage()">
                                <mat-icon>fullscreen</mat-icon>
                            </button>
                            <input
                                hidden
                                type="file"
                                id="imageUpload"
                                accept=".png, .jpg, .jpeg"
                                #fileInput
                                (change)="uploadImage($event, itemForm.form)"
                            />
                        </div>
                        @if (canUploadImage()) {
                            <button
                                mat-raised-button
                                class="cb-margin-top"
                                (click)="fileInput.click()"
                            >
                                <mat-icon>file_upload</mat-icon>
                                <span> &nbsp;Upload Image </span>
                            </button>
                        }
                        @if (canRemoveImage()) {
                            <button
                                class="cb-margin-top"
                                mat-raised-button
                                (click)="removeImage(itemForm.form)"
                            >
                                <mat-icon>delete</mat-icon>
                                &nbsp;Remove Image
                            </button>
                        }
                    </div>
                    <div class="flex-col flex-80">
                        @if (!isQuoted()) {
                            @for (restriction of mappedItem?.restrictions; track restriction) {
                                <div class="restriction">
                                    <cb-select
                                        [name]="'option' + restriction.name"
                                        [label]="restriction.name"
                                        [(ngModel)]="restriction.selectedOptionId"
                                        noOptionsMessage="-"
                                        [readonly]="!isEditOrAdd()"
                                        [options]="restriction.options"
                                    ></cb-select>
                                    <cb-input
                                        type="text"
                                        [name]="'note' + restriction.name"
                                        label="Notes"
                                        [required]="false"
                                        [(ngModel)]="restriction.notes"
                                    >
                                    </cb-input>
                                </div>
                            }
                        }
                        @if (mappedItem.manualColourEntryRequired) {
                            <div class="restriction">
                                <cb-input
                                    type="text"
                                    name="manualColour"
                                    label="Manual Colour Entry"
                                    [required]="false"
                                    [(ngModel)]="mappedItem.manualColourName"
                                >
                                </cb-input>
                                <cb-input
                                    type="text"
                                    name="manualColournotes"
                                    label="Notes"
                                    [required]="false"
                                    [(ngModel)]="mappedItem.manualColourNotes"
                                >
                                </cb-input>
                            </div>
                        }
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
        <cb-nullable-boolean
            label="Include in Flyer / Create Schedule"
            name="showInClientSpecification"
            [(ngModel)]="mappedItem.showInClientSpecification"
            nullLabel="Not Set (Inherit from Product)"
        >
        </cb-nullable-boolean>
        <cb-nullable-boolean
            label="Include in Colour Schedule"
            name="showInColourYourDreams"
            [(ngModel)]="mappedItem.showInColourYourDreams"
            nullLabel="Not Set (Inherit from Product)"
            #includeInColourSchedule
        >
        </cb-nullable-boolean>
        <cb-nullable-boolean
            label="Manual Colour Entry Required"
            name="manualColourEntryRequired"
            (change)="manualColourEntryRequiredChanged($event)"
            [(ngModel)]="mappedItem.manualColourEntryRequired"
            nullLabel="Not Set (Inherit from Product)"
        >
        </cb-nullable-boolean>
    </form>
    <div actions>
        <button
            mat-raised-button
            color="primary"
            (cbClick)="saveItem(itemForm)"
            [clickLimit]="1"
            [disabled]="itemForm.pristine || itemForm.invalid || isLoading"
        >
            Save
        </button>
        <button mat-raised-button (cbClick)="cancel()">Cancel</button>
    </div>
</cb-dialog>
